module.exports = __webpack_public_path__ + "img/Icon_@ID.d11bb4c2.svg";